import React, { Fragment, useEffect, useState } from "react"
import { Field, Formik, Form } from "formik"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import compose from "ramda/src/compose"
import _get from "lodash/get"

import Typograph from "components/Typograph"
import ModernFloatLabelInput from "shared/components/ModernFloatLabelInput"
import HeaderForm from "../HeaderForm"
import FooterForm from "../FooterForm"
import ModernFloatLabelSelect from "shared/components/ModernFloatLabelSelect"
import InputCheckbox from "components/InputCheckbox"
import Loading from "components/Loading"

import styles from "./styles.css"

import {
  date,
  maskCNPJ,
  maskCPF,
  maskCurrencyBR,
  maskTel
} from "services/utils/mask"
import { stepTwoValidation } from "../validationForm"
import { getEnergyDistributor } from "services/state/gedisa/actions"

const accountHolderOptions = [
  {
    label: "Pessoa física",
    value: "PF"
  },
  {
    label: "Pessoa jurídica",
    value: "PJ"
  }
]

function EnergyDataStep({
  onNextStep,
  onPreviousStep,
  setFormData,
  formData,
  getEnergyDistributor,
  customer
}) {
  const {
    issueDateOne,
    billOne,
    issueDateTwo,
    billTwo,
    name,
    cpf,
    birthDate,
    phoneNumber,
    email,
    isSameDataResponsible,
    accountHolder,
    energyDistributor,
    customerNumber,
    holderName,
    holderCpf,
    holderBirthDate,
    holderPhoneNumber,
    holderEmail
  } = formData
  const [isResponsibleData, setIsResponsibleData] = useState(false)
  const [distributor, setDistributor] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const documentNumber = _get(customer, "documentNumber", "")
  const companyName = _get(customer, "name", "")

  const optionsEnergy = distributor.map((item) => {
    return {
      label: item.nome_reduzido,
      value: item.id
    }
  })

  useEffect(() => {
    setIsLoading(true)
    getEnergyDistributor(
      (response) => {
        setIsLoading(false)

        if (response.payload && response.payload.data) {
          setDistributor(response.payload.data.data)
        }
      },
      (error) => {
        setIsLoading(false)
        console.error("Error data fetching getEnergyDistributor", error)
      }
    )
  }, [])

  const handleChangeNextStep = (values) => {
    setFormData((prevState) => ({ ...prevState, ...values }))
    onNextStep()
  }
  const handleChangePreviousStep = () => {
    onPreviousStep()
  }

  const handleChangeResponsibleData = (checked, form) => {
    if (checked) {
      form.setValues((prevState) => {
        return {
          ...prevState,
          holderName: name,
          holderCpf: cpf,
          holderBirthDate: birthDate,
          holderPhoneNumber: phoneNumber,
          holderEmail: email,
          isSameDataResponsible: true
        }
      })

      return
    }

    form.setValues((prevState) => {
      return {
        ...prevState,
        holderName: "",
        holderCpf: "",
        holderBirthDate: "",
        holderPhoneNumber: "",
        holderEmail: "",
        isSameDataResponsible: false
      }
    })
  }

  return (
    <div>
      <Loading isOpen={isLoading} />
      <HeaderForm
        title="Abrir solicitação de adesão"
        description="Informações de consumo"
      />
      <div>
        <Formik
          initialValues={{
            issueDateOne,
            billOne,
            issueDateTwo,
            billTwo,
            isSameDataResponsible,
            accountHolder,
            energyDistributor,
            customerNumber,
            holderName,
            holderCpf,
            holderBirthDate,
            holderPhoneNumber,
            holderEmail
          }}
          validationSchema={stepTwoValidation}
          validateOnMount
          enableReinitialize
        >
          {({ isValid, values }) => {
            const isTypePF = values.accountHolder === "PF"

            return (
              <Form>
                <Field name="energyDistributor">
                  {({ field, meta, form }) => {
                    const selected =
                      optionsEnergy.find((opt) => opt.value === field.value) ||
                      null

                    return (
                      <ModernFloatLabelSelect
                        id="energyDistributor"
                        value={selected}
                        options={optionsEnergy}
                        label="Sua distribuidora de energia*"
                        error={meta.touched && meta.error}
                        onChange={(e) => {
                          form.setFieldValue(field.name, e.value, false)
                        }}
                      />
                    )
                  }}
                </Field>
                <Field name="customerNumber">
                  {({ field, meta }) => (
                    <ModernFloatLabelInput
                      {...field}
                      id="customerNumber"
                      label="Número do cliente/instalação"
                      error={meta.touched && meta.error}
                      margin="top_5"
                    />
                  )}
                </Field>

                <Typograph
                  htmlTag="p"
                  size="medium"
                  weight="medium"
                  color="outer_space"
                  classNames={styles.description}
                >
                  Informe os dados do titular da conta de energia
                </Typograph>

                <Field name="accountHolder">
                  {({ field, form, meta }) => {
                    const selected =
                      accountHolderOptions.find(
                        (item) => item.value === field.value
                      ) || null
                    return (
                      <ModernFloatLabelSelect
                        id="accountHolder"
                        options={accountHolderOptions}
                        value={selected}
                        label="Tipo de titular"
                        error={meta.touched && meta.error}
                        onChange={(e) => {
                          form.setFieldValue(field.name, e.value)
                        }}
                      />
                    )
                  }}
                </Field>

                {!isTypePF && (
                  <Fragment>
                    <Field name="companyName">
                      {({ field }) => (
                        <ModernFloatLabelInput
                          {...field}
                          id="companyName"
                          label="Nome da empresa*"
                          disabled
                          value={companyName}
                        />
                      )}
                    </Field>
                    <Field name="cnpj">
                      {({ field }) => (
                        <ModernFloatLabelInput
                          {...field}
                          id="cnpj"
                          label="CNPJ*"
                          disabled
                          value={maskCNPJ(documentNumber)}
                        />
                      )}
                    </Field>
                  </Fragment>
                )}
                {isTypePF && (
                  <Fragment>
                    <div className={styles.checkBox}>
                      <Field name="isSameDataResponsible">
                        {({ field, form }) => (
                          <InputCheckbox
                            id="isSameDataResponsible"
                            label="Usar informações do responsável legal"
                            customLabel={styles.checkboxLabel}
                            checked={isResponsibleData}
                            onChange={(e) => {
                              const checked = e.target.checked
                              setIsResponsibleData(checked)

                              form.setFieldValue(field.name, checked, false)
                              handleChangeResponsibleData(checked, form, field)
                            }}
                          />
                        )}
                      </Field>
                    </div>
                    <Field name="holderName">
                      {({ field, meta }) => (
                        <ModernFloatLabelInput
                          {...field}
                          id="holderName"
                          label="Nome completo*"
                          error={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                    <div className={styles.gridForm}>
                      <Field name="holderCpf">
                        {({ field, meta, form }) => (
                          <ModernFloatLabelInput
                            {...field}
                            id="holderCpf"
                            label="CPF*"
                            error={meta.touched && meta.error}
                            maxLength={14}
                            onChange={(e) => {
                              const masked = maskCPF(e.target.value)
                              form.setFieldValue(field.name, masked)
                            }}
                          />
                        )}
                      </Field>
                      <Field name="holderBirthDate">
                        {({ field, meta, form }) => (
                          <ModernFloatLabelInput
                            {...field}
                            id="holderBirthDate"
                            label="Data de nascimento*"
                            error={meta.touched && meta.error}
                            onChange={(e) => {
                              const masked = date(e.target.value)
                              form.setFieldValue(field.name, masked)
                            }}
                          />
                        )}
                      </Field>
                    </div>

                    <div className={styles.gridForm}>
                      <Field name="holderPhoneNumber">
                        {({ field, meta, form }) => (
                          <ModernFloatLabelInput
                            {...field}
                            id="holderPhoneNumber"
                            label="Celular*"
                            error={meta.touched && meta.error}
                            maxLength={15}
                            onChange={(e) => {
                              const masked = maskTel(e.target.value)
                              form.setFieldValue(field.name, masked)
                            }}
                          />
                        )}
                      </Field>
                    </div>

                    <Field name="holderEmail">
                      {({ field, meta }) => (
                        <ModernFloatLabelInput
                          {...field}
                          id="holderEmail"
                          label="E-mail*"
                          error={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                  </Fragment>
                )}

                <Typograph
                  htmlTag="p"
                  size="medium"
                  weight="medium"
                  color="outer_space"
                  classNames={styles.description}
                >
                  Informe a data de emissão e o consumo das suas 2 últimas
                  contas de energia
                </Typograph>

                <div>
                  <Typograph
                    htmlTag="span"
                    size="extra_small"
                    weight="bold"
                    color="outer_space"
                  >
                    Conta 1
                  </Typograph>
                  <div className={styles.form}>
                    <Field name="issueDateOne">
                      {({ field, meta, form }) => (
                        <ModernFloatLabelInput
                          {...field}
                          id="issueDateOne"
                          label="Data de emissão*"
                          error={meta.touched && meta.error}
                          margin="top_0"
                          onChange={(e) => {
                            const masked = date(e.target.value)
                            form.setFieldValue(field.name, masked)
                          }}
                        />
                      )}
                    </Field>
                    <Field name="billOne">
                      {({ field, meta, form }) => (
                        <ModernFloatLabelInput
                          {...field}
                          id="billOne"
                          label="Consumo da fatura*"
                          error={meta.touched && meta.error}
                          margin="top_0"
                          onChange={(e) => {
                            const masked = maskCurrencyBR(e.target.value)
                            form.setFieldValue(field.name, masked)
                          }}
                        />
                      )}
                    </Field>
                  </div>
                </div>

                <Typograph
                  htmlTag="span"
                  size="extra_small"
                  weight="bold"
                  color="outer_space"
                >
                  Conta 2
                </Typograph>

                <div className={styles.form}>
                  <Field name="issueDateTwo">
                    {({ field, meta, form }) => (
                      <ModernFloatLabelInput
                        {...field}
                        id="issueDateTwo"
                        label="Data de emissão*"
                        error={meta.touched && meta.error}
                        margin="top_0"
                        onChange={(e) => {
                          const masked = date(e.target.value)
                          form.setFieldValue(field.name, masked)
                        }}
                      />
                    )}
                  </Field>
                  <Field name="billTwo">
                    {({ field, meta, form }) => (
                      <ModernFloatLabelInput
                        {...field}
                        id="billTwo"
                        label="Consumo da fatura*"
                        error={meta.touched && meta.error}
                        margin="top_0"
                        onChange={(e) => {
                          const masked = maskCurrencyBR(e.target.value)
                          form.setFieldValue(field.name, masked)
                        }}
                      />
                    )}
                  </Field>
                </div>

                <FooterForm
                  onClickNext={() => handleChangeNextStep(values)}
                  onClickPrevious={handleChangePreviousStep}
                  step="2"
                  disabled={!isValid}
                  textPrevious="Voltar"
                  textNext="Avançar"
                  type="button"
                />
              </Form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}
EnergyDataStep.propTypes = {
  onReset: PropTypes.func,
  onNextStep: PropTypes.func,
  setStep: PropTypes.func,
  onPreviousStep: PropTypes.func,
  setFormData: PropTypes.func,
  formData: PropTypes.object,
  getEnergyDistributor: PropTypes.func,
  customer: PropTypes.object
}
const enhance = compose(
  connect(null, {
    getEnergyDistributor
  })
)
export default enhance(EnergyDataStep)



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/RequestForm/components/EnergyDataStep/index.js